import React from 'react'
import SystemActivityPage from '../../Components/Layout/Admin/SystemActivityPage'

function Activitylog() {
  return (
    <SystemActivityPage/>
  )
}

export default Activitylog